<template>
  <div class="h-full overflow-x-hidden">
    <div v-if="appointment" class="h-full">
      <div>
        <AppointmentStatusDropdown
          :appointment="appointment"
          @refresh-appointment="fetchAppointment"
        />
      </div>
      <div>
        <AppointmentServiceCategory
          :appointment="appointment"
          @refresh-appointment="fetchAppointment"
        />
        <NavTab :tabs="tabs" variant="default" />
      </div>
      <div class="py-4 px-8 bg-gray-50 -mx-4 h-full">
        <component
          :is="tabComponent"
          :appointment="appointment"
          @refresh-appointment="fetchAppointment"
        />
      </div>
    </div>
    <div v-else class="h-full flex items-center justify-center">
      <Spinner />
    </div>
  </div>
</template>

<script setup lang="ts">
import { computed, onMounted, ref } from "vue";
import { useStore } from "vuex";

import NavTab from "@/components/Seranova/NavTab/NavTab.vue";
import Spinner from "@/components/Seranova/Spinner/Spinner.vue";
import { AppointmentV2 } from "@/typings/appointment";
import AppointmentDetailsTab from "./AppointmentDetailsTab.vue";
import AppointmentServiceCategory from "./AppointmentServiceCategory.vue";
import AppointmentStatusDropdown from "./AppointmentStatusDropdown.vue";
const emit = defineEmits(["appointment-change"]);
const props = defineProps<{ appointmentId: string | number }>();
const appointment = ref<AppointmentV2 | null>(null);

const store = useStore();
const activeTab = ref("Details");

const tabs = computed(() => {
  return [{ label: "Details", active: true }];
});

const tabComponent = computed(() => {
  switch (activeTab.value) {
    default:
      return AppointmentDetailsTab;
  }
});

onMounted(() => {
  fetchAppointment();
});

const fetchAppointment = async () => {
  appointment.value = await store.dispatch("fetchAppointmentDetails", {
    id: props.appointmentId
  });
  emit("appointment-change", appointment.value);
};
</script>

<style></style>
